import { useContext } from 'react';
import { CancellationPolicyNotice as WrappedCancellationPolicyNotice } from '@components/cancellationPolicyNotice/CancelationPolicyNotice';
import { type CancellationPolicy } from '@shared/types/reservations';
import { AvailabilityContext } from 'webReservations/context/AvailabilityContext';
import { withCancellationPolicy } from 'webReservations/context/withCancellationPolicy';

interface CancellationPolicyNoticeProps {
  date: string;
  cancellationPolicy: CancellationPolicy;
  purchasePrice?: number;
  availabilityTime?: string;
}

export const CancellationPolicyNotice = withCancellationPolicy(
  ({
    cancellationPolicy,
    date,
    purchasePrice,
    availabilityTime,
  }: CancellationPolicyNoticeProps) => {
    const availability = useContext(AvailabilityContext);
    const resolvedPrice =
      purchasePrice ??
      availability?.selectedAvailability?.purchasePrice ??
      null;
    const resolvedTime =
      availabilityTime ?? availability?.selectedAvailability?.time;
    if (resolvedPrice === null || !resolvedTime) return null;

    return (
      <WrappedCancellationPolicyNotice
        date={date}
        purchasePrice={resolvedPrice}
        availabilityTime={resolvedTime}
        hoursBeforeReservation={cancellationPolicy.hoursBeforeReservation}
        threshold={cancellationPolicy.threshold}
        cancellationFee={cancellationPolicy.fee}
      />
    );
  },
);
